import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Background from 'components/common/Background';
import corner4 from 'assets/img/illustrations/corner-4.png';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';
import Avatar from 'components/common/Avatar';
import IconAlert from 'components/common/IconAlert';
import dayjs from 'dayjs';

const Profile = ({ watch, setValue, register, errors }) => {
 return (
  <Card className="my-3">
   <Background
    image={corner4}
    className="bg-card"
    style={{
     borderTopRightRadius: '0.375rem',
     borderBottomRightRadius: '0.375rem'
    }}
   />
   <Card.Body className="position-relative fs--1">
    {errors.logo && <IconAlert variant="warning">{errors.logo.message}!</IconAlert>}
    <Flex wrap="wrap" alignContent="center" alignItems="center" justifyContent="center" className="mb-0">
     <Avatar
      uploader
      size="5xl"
      src={watch('logo')}
      mediaClass="img-thumbnail shadow-sm"
      propUploader={{
       iconClass: 'me-4',
       classInput: 'logo',
       multiple: false,
       register: register('logo', { required: 'El logo es requerido' }),
       onChange: img => {
        setValue('logo', img, { shouldValidate: true, shouldTouch: true });
       }
      }}
     />
     <div className="flex-grow-1 border-md-start border-start-2 ms-md-3 ps-md-1">
      <Input
       type="text"
       errors={errors}
       label="Nombre*"
       name="name"
       placeholder="Nombre del proyecto"
       formGroupProps={{ className: 'p-2' }}
       formLabelProps={{ className: 'mb-0 fs--1' }}
       formControlProps={{
        ...register('name', {
         required: 'Debe especificar el nombre del proyecto',
         validate: value => !/[^a-zA-Z0-9_-ñ Ñ]/g.test(value) || 'El nombre debe tener caracteres validos',
         minLength: {
          value: 5,
          message: 'El nombre debe tener al menos 5 caracteres'
         }
        }),
        size: 'sm',
        autoComplete: 'off'
        //defaultValue: data?.name
       }}
      />

      <Flex wrap="wrap">
       <Input
        type="simple-date"
        errors={errors}
        label="Inicio*"
        name="projectStart"
        formGroupProps={{ className: 'flex-fill p-2' }}
        formLabelProps={{ className: 'mb-0 fs--1' }}
        formControlProps={{
         ...register('projectStart', {
          required: 'Debe establecer una fecha',
          valueAsDate: true
         }),
         size: 'sm',
         autoComplete: 'off',
         defaultValue: dayjs(watch('projectStart')).format('DD/MM/YYYY')
        }}
       />

       <Input
        type="simple-date"
        errors={errors}
        label="Fin*"
        name="projectEnd"
        formGroupProps={{ className: 'flex-fill p-2' }}
        formLabelProps={{ className: 'mb-0 fs--1' }}
        formControlProps={{
         ...register('projectEnd', {
          required: 'Debe establecer una fecha',
          valueAsDate: true
         }),
         size: 'sm',
         autoComplete: 'off',
         defaultValue: dayjs(watch('projectEnd')).format('DD/MM/YYYY')
        }}
       />
      </Flex>
     </div>
    </Flex>
   </Card.Body>
  </Card>
 );
};

Profile.propTypes = { watch: PropTypes.func, setValue: PropTypes.func, register: PropTypes.func, errors: PropTypes.object };

export default Profile;
